module.exports = __webpack_public_path__ + "0ba9f412781f82b33015ce125cd4581a.svg";